import { makeStyles } from '@material-ui/core/styles';
import { designTokens } from '../../styles/designTokens';

export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: 0,
        borderRadius: designTokens.borderRadius.modal,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        minWidth: 320,
        '@media (max-width: 768px)': {
            minWidth: 'auto',
            width: '100%',
        }
    },

    inputWrapper: {
        position: 'relative',
    },
    input: {
        display: 'flex',
        alignItems: 'center',
        padding: `${designTokens.spacing.md} ${designTokens.spacing.lg}`,
        border: `1px solid ${designTokens.colors.border}`,
        borderRadius: designTokens.borderRadius.button,
        cursor: 'pointer',
        backgroundColor: designTokens.colors.background.page,
        transition: 'border-color 0.2s',
        '&:hover': {
            borderColor: designTokens.colors.primary,
        },
        '&:focus-within': {
            borderColor: designTokens.colors.primary,
            boxShadow: `0 0 0 2px ${designTokens.colors.primary}20`,
        }
    },
    inputIcon: {
        marginRight: 12,
        color: designTokens.colors.primary,
        fontSize: '24px',
    },
    inputText: {
        ...designTokens.typography.placeholder,
        color: designTokens.colors.text.primary,
    },
    inputPlaceholder: {
        ...designTokens.typography.placeholder,
        color: designTokens.colors.text.secondary,
    },

    calendarSection: {
        padding: 20,
    },
    calendarHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
    },
    monthYearLabel: {
        ...designTokens.typography.body,
        fontWeight: 500,
    },
    navigationButton: {
        padding: 8,
        '&:hover': {
            backgroundColor: designTokens.colors.grey[100],
        }
    },

    weekdaysRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 4,
        marginBottom: 8,
    },
    weekdayLabel: {
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        color: designTokens.colors.text.secondary,
        padding: '8px 0',
    },
    daysGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
    },

    day: {
        position: 'relative',
        aspectRatio: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 15,
        fontWeight: 400,
        color: designTokens.colors.text.primary,
        cursor: 'pointer',
        borderRadius: 24,
        transition: 'all 0.2s',
        border: 'none',
        backgroundColor: 'transparent',
        fontFamily: designTokens.fontFamily,
        '&:hover': {
            backgroundColor: designTokens.colors.grey[100],
        },
        '&:disabled': {
            color: designTokens.colors.text.disabled,
            cursor: 'not-allowed',
            '&:hover': {
                backgroundColor: 'transparent',
            }
        }
    },
    dayOutsideMonth: {
        color: designTokens.colors.text.disabled,
    },
    daySelected: {
        backgroundColor: designTokens.colors.primary,
        color: designTokens.colors.white,
        fontWeight: 600,
        borderRadius: 24,
        '&:hover': {
            backgroundColor: designTokens.colors.primaryDark,
        }
    },
    dayToday: {
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 4,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 4,
            height: 4,
            borderRadius: '50%',
            backgroundColor: designTokens.colors.primary,
        }
    }
}));
